import { reactive } from 'vue'
import { HttpClass } from '../../../shared/http/HttpClass';
import { GoogleSheetsClass } from '../../../shared/helpers/GoogleSheetsClass';
import { state } from './stateWidget';
import { time } from '../../../store/time/storeTime';

// EXPORT
export const widget = reactive({
    
    determineWidgetStep() {
        const widgetSettings = state.getWidgetSettings();
        
        /* LOOP THROUGH WIDGET SETTINGS */
        widgetSettings.every(item => {
            const withinStep = time.isBetweenTimes(item.start, item.stop);
            
            if(withinStep === true) {
                // UPDATE STATE
                state.setCurrentWidgetStep(item);

                return false; // EXIT LOOP
            }

            return true;
        });
    },

    async fetchWidgetSettings() {
        const gs = new GoogleSheetsClass({
            sheetID: '1CwziG-siLFUihMUs-IC2GJcUSGGeyLj7cD4pNc2Cwls',
            range: 'A:Z',
        });

        const gsUrl = gs.createGoogleSheetsUrl();

        const http = new HttpClass({
            useCacher: true,
            cacherLabel: 'cfm_ec_widget_settings',
            cacherUrl: gsUrl,
            cacherForceReload: false,
            cacherTimeout: 5 // minutes
        });

        const cacherUrl = http.buildCacherUrl();

        // MAKE REQUEST
        const res = await http.sendRequest(cacherUrl);
        
        // NORMALIZE RESULTS
        res.data = this.normalizeWidgetSettings(res.data);

        return res;
    },

    normalizeWidgetSettings(widgetSettings) {
        // CREATE BUTTONS ARRAY
        widgetSettings.forEach((item, index) => {
            let endOfButtons = false;
            let i = 1;
            let buttons = [];
            
            // LOOP UNTIl NO BUTTONS ARE FOUND
            do {
                if(item['button'+i+'text']) {
                    buttons.push({
                        label: item['button'+i+'text'],
                        link: item['button'+i+'link'],
                        icon: item['button'+i+'icon'],
                    });

                    i++;
                }
                else {
                    endOfButtons = true;
                }
            } 
            while (endOfButtons === false);

            // ADD BUTTONS ARRAY TO ITEM
            widgetSettings[index].buttons = buttons;
        });
        
        return widgetSettings;
    },

    state,

});